import { Box, MenuItem, Typography } from "@mui/material";
import type { JSX } from "react";

interface Props {
  icon: JSX.Element;
  title: string | JSX.Element;
  disabled?: boolean;
  onClick: () => void;
}

const ActionMenuItem = ({ icon, title, disabled, onClick }: Props) => {
  return (
    <MenuItem onClick={onClick} disabled={disabled} sx={{ color: "secondary.main" }}>
      {icon}
      {typeof title === "string" && (
        <Typography color="textPrimary" sx={{ pl: 1 }}>
          {title}
        </Typography>
      )}
      {typeof title !== "string" && <Box sx={{ pl: 1, color: "text.primary" }}>{title}</Box>}
    </MenuItem>
  );
};

export default ActionMenuItem;
